<template>
  <section>
    <v-row class="mb-4" no-gutters>
      <v-col>
        <p class="sms-recover-number">{{hiddenPhone}}</p>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-text-field
        outlined
        hide-details
        v-mask="documentMask"
        :label="label"
        class="mb-5"
        v-model="cpfOrCnpj"
        disabled
      />
    </v-row>
    <v-row no-gutters>
      <v-text-field
        outlined
        label="Confirme seu telefone"
        class="mb-5"
        v-mask="['(##) ####-#####', '(##) # ####-####']"
        v-model="phoneNumber"
        :error-messages="phoneConfirmError"
        @input="$emit('remove-error')"
        type="text"
      />
    </v-row>
    <v-row class="mb-3" no-gutters>
      <v-btn width="100%" class="button-height" :color="getAssets.colors.form.buttonBackground" :style="{ color: getAssets.colors.form.buttonFont }" :loading="btnLoading" @click="submitPhoneNumber" :disabled="phoneConfirm.length < 14">enviar código</v-btn>
    </v-row>
  </section>
</template>

<script>
import { documentMaskMixin } from '@/mixins/document-mask'
export default {
  props: {
    hiddenPhone: String,
    label: String,
    cpfCnpj: String,
    phoneConfirm: String,
    phoneConfirmError: String,
    btnLoading: Boolean
  },
  mixins: [documentMaskMixin],
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    cpfOrCnpj: {
      get() {
        return this.cpfCnpj
      },
      set(value) {
        this.$emit('set-cpf-cnpj', value)
      }
    },
    phoneNumber: {
      get() {
        return this.phoneConfirm
      },
      set(value) {
        this.$emit('set-phone-confirm', value)
      }
    }
  },
  methods: {
    submitPhoneNumber() {
      this.$emit('submit')
    }
  }
}
</script>
